import { authenticationService } from '_services';
import { history } from '_helpers';

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authenticationService.logout();
                history.push('/admin/login');
                // location.reload(true);
            } else if(response.status === 404){
            // To-Do handle 404 
            } else if(response.status === 500){
                history.push('/admin/error');
            }

            const error = (data && data.message) || response.statusText || response.status;
            return Promise.reject(error);
        }

        return data;
    });
}